// Browser push notification helper (foreground notifications + web-push subscription).
import { api } from './api';

export async function getNotifPermission() {
  if (!('Notification' in window)) return 'unsupported';
  return Notification.permission;
}

export async function requestNotifPermission() {
  if (!('Notification' in window)) return 'unsupported';
  try {
    const perm = await Notification.requestPermission();
    if (perm === 'granted') {
      // Best-effort: also subscribe this device to web-push so the OS shows
      // notifications even when the tab is closed.
      subscribeToPush().catch(() => null);
    }
    return perm;
  } catch (err) {
    console.debug('push: permission request failed', err);
    return 'denied';
  }
}

export function showBrowserNotification(title, body, link) {
  if (!('Notification' in window) || Notification.permission !== 'granted') return;
  try {
    const n = new Notification(title, { body, icon: '/icon-192.png', tag: link || title });
    if (link) {
      n.onclick = () => { window.focus(); window.location.href = link; };
    }
  } catch (err) { console.debug('push: non-fatal', err); }
}

// ---------- Web Push (VAPID) ----------
function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = window.atob(base64);
  const output = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; ++i) output[i] = raw.charCodeAt(i);
  return output;
}

export async function subscribeToPush() {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) return null;
  if (Notification.permission !== 'granted') return null;

  const reg = await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();

  if (!sub) {
    let publicKey = '';
    try {
      const { data } = await api.get('/push/public-key');
      publicKey = data.public_key || '';
    } catch (err) { console.debug('push: unavailable', err); return null; }
    if (!publicKey) return null;
    try {
      sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(publicKey),
      });
    } catch (err) { console.debug('push: unavailable', err); return null; }
  }

  try {
    const json = sub.toJSON();
    await api.post('/push/subscribe', {
      endpoint: json.endpoint,
      keys: json.keys,
      user_agent: navigator.userAgent,
    });
  } catch (err) { console.debug('push: subscribe sync deferred, server will get it next time', err); }
  return sub;
}

export async function unsubscribeFromPush() {
  if (!('serviceWorker' in navigator)) return;
  try {
    const reg = await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.getSubscription();
    if (!sub) return;
    const endpoint = sub.endpoint;
    await sub.unsubscribe();
    try { await api.post('/push/unsubscribe', { endpoint }); } catch (err) { console.debug('push: non-fatal', err); }
  } catch (err) { console.debug('push: non-fatal', err); }
}
